import React from "react";
import { useState } from "react";
import { FaPhone, FaEnvelope, FaHome } from "react-icons/fa";
import { Helmet } from "react-helmet";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowModal(true);
    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta
          name="description"
          content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali."
        />
      </Helmet>

      <div className="contact-page">
        <h2 className="section-title">Contattaci</h2>

        <div className="contact-container">
          <div className="contact-info">
            <h3>Informazioni di Contatto</h3>

            <div className="contact-item">
              <FaHome className="contact-item-icon" />
              <div className="contact-item-content">
                <h4>Indirizzo</h4>
                <p>
                  Piazza Luigi Ceriana, 15121 Alessandria AL
                  <br />
                  Italia
                </p>
              </div>
            </div>

            <div className="contact-item">
              <FaPhone className="contact-item-icon" />
              <div className="contact-item-content">
                <h4>Telefono</h4>
                <p>+393923212000</p>
              </div>
            </div>

            <div className="contact-item">
              <FaEnvelope className="contact-item-icon" />
              <div className="contact-item-content">
                <h4>Email</h4>
                <p>
                  <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
                </p>
              </div>
            </div>

            <div className="contact-item">
              <div className="contact-item-content">
                <h4>Orari di Apertura</h4>
                <p>
                  Lunedi - Venerdi: 9:00 - 18:00
                  <br />
                  Sabato: 10:00 - 16:00
                  <br />
                  Domenica: Chiuso
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h3>Inviaci un Messaggio</h3>
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <label htmlFor="firstName">Nome *</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="lastName">Cognome *</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefono</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  pattern="^\+?[0-9\s\-]{7,20}$"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Messaggio *</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Invia Messaggio
              </button>
            </form>
          </div>
        </div>

        {showModal && (
          <div className="modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Grazie per averci contattato</h3>
              <p>
                Il tuo messaggio e stato inviato con successo. Ti risponderemo
                al piu presto possibile.
              </p>
              <button className="modal-close-btn" onClick={closeModal}>
                Chiudi
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Contact;
